import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const UICounter = (props) => {
	useStyles(css);
	const {
		label,
		icon,
		iconActive,
		color,
		isReverse,
		isActive,
		onClick,
		children,
	} = props;

	return (
		<div className={css.group}>
			<div
				className={cn(css.wrap, css[`wrap--color--${color}`], {
					[css[`wrap--bool--isReverse`]]: isReverse,
				})}
				tabIndex={0}
				role="button"
				onClick={onClick}
			>
				{icon && (
					<span className={css.icon}>
						{(isActive && iconActive) || icon}
					</span>
				)}
				{label && <span className={css.label}>{label}</span>}
			</div>

			{children && (
				<div className={css.hintGroup}>
					<div className={css.hint}>{children}</div>
				</div>
			)}
		</div>
	);
};

UICounter.propTypes = {
	label: PropTypes.string,
	icon: PropTypes.element,
	iconActive: PropTypes.element,
	color: PropTypes.oneOf(['blue', 'grey', 'white']),
	onClick: PropTypes.func,
	isReverse: PropTypes.bool,
	isActive: PropTypes.bool,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
};

UICounter.defaultProps = {
	label: undefined,
	icon: undefined,
	iconActive: undefined,
	color: 'blue',
	onClick: undefined,
	isReverse: false,
	isActive: false,
	children: undefined,
};

export default UICounter;
